/**
 * The calendar every "which day / week / month does this count in" question is
 * answered in: usage statistics, the free voice quota's monthly and daily
 * windows, billing, back-office reports that group or total by day, and
 * monitoring roll-ups. A day runs from 00:00 to 24:00 in this zone, whatever
 * zone the server process runs in. Taipei has no daylight saving, so a day is
 * always 24 hours long.
 *
 * A date that decides a number, a quota or a rule uses this zone, and so does
 * text the server renders for a person (PDF, Slack, email), because the server
 * does not know the reader's zone. Showing a moment on screen (a list's today /
 * yesterday heading, a timestamp) follows the viewer's own device time zone.
 *
 * The iOS app keeps the same value in `DayBoundary.timeZone`
 * (`apps/ios/KiaoVoice/App/day-boundary.swift`), reconciled by
 * `apps/ios/scripts/day-boundary-time-zone.test.mjs`.
 */
export const DAY_BOUNDARY_TIME_ZONE = 'Asia/Taipei'

const DATE_KEY_FORMAT = new Intl.DateTimeFormat('en-CA', {
  timeZone: DAY_BOUNDARY_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

/** `YYYY-MM-DD` of `instant` on the {@link DAY_BOUNDARY_TIME_ZONE} calendar. */
export function dayBoundaryDateKey(instant: Date): string {
  const parts = DATE_KEY_FORMAT.formatToParts(instant)
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? ''
  return `${value('year')}-${value('month')}-${value('day')}`
}
